export enum LangEnum {
    "FR" = "fr",
    "ES" = "es",
    "PT" = "pt",
    "SL" = "sl"
}
